'use strict';

/**
 * @module main
 * @author Sebastian Pekarek
 */

require('core-js/stable');
require('regenerator-runtime/runtime');
require('@webcomponents/webcomponentsjs');
require('@babel/register');


//const $ = require('zepto');
const Sentry = require('@sentry/browser');
const DataHelper = require('./helpers/data');
const ConfigurationHelper = require('./helpers/configuration');
const MapView = require('./views/map');


// initialize raven / sentry
if (ConfigurationHelper.getSentryDSN()) {
	Sentry.init({
		dsn: ConfigurationHelper.getSentryDSN(),
		release: ConfigurationHelper.getVersion(),
		environment: ConfigurationHelper.getBuildEnvironment(),
		tags: {
			commit: ConfigurationHelper.getBuildCommit()
		}
	});
}

Error.stackTraceLimit = 50;
DataHelper.initialize().catch(err => console.log(err));

window.__initialize = () => {
	new MapView();
};
if(window.__initialized) {
	window.__initialize();
}
